import { ReasonFilterRequest, ReasonRequest } from "@/main/models/request";
import { ReasonTypes, ReasonActionTypes } from "./reasonTypes";

export function getReason(request: ReasonFilterRequest): ReasonActionTypes {
	return {
		type: ReasonTypes.GET_REASON,
		payload: { request },
	};
}

export function saveReason(
	data: ReasonRequest[] | null,
	isError: boolean,
	errorMessages: string[] | null,
): ReasonActionTypes {
	return {
		type: ReasonTypes.SAVE_REASON,
		payload: { data, isError, errorMessages },
	};
}

export function resetReducerReason(): ReasonActionTypes {
	return {
		type: ReasonTypes.RESET_REDUCER_REASON,
	};
}
